"use client";

import Image from "next/image";
import useUtility from "@/app/_hooks/useUtility";
import { useSection } from "./_hooks/useSection";
import MissionVisionSkeleton from "./_skeletons/MissionVisionSkeleton";
import { frontendImage } from "@/lib/helpers";
import missionBg from "@/public/images/thumbs/mission-vision-bg.png";

export const MissionVision = () => {
  const { trans } = useUtility();
  const { content, elements, loading } = useSection("mission_vision");

  if (loading) {
    return <MissionVisionSkeleton />;
  }

  return (
    <section
      className="mission-vision-section py-60 bg-img"
      data-background-image="/assets/images/thumbs/mission-vision-bg.png"
      style={{
        backgroundImage: `url(${missionBg.src})`,
      }}
    >
      <div className="container">
        <div className="row">
          {/* Left side: Text blocks */}
          <div className="col-xl-6 col-lg-7">
            {elements?.map((item, idx) => (
              <div className="mission-vision-item" key={idx}>
                <h5 className="mission-vision-item__title text--warning">
                  {trans(item.title)}
                </h5>
                <div
                  className="mission-vision-item__desc"
                  dangerouslySetInnerHTML={{
                    __html: item.description || "",
                  }}
                />
              </div>
            ))}
          </div>

          {/* Right side: Image */}
          <div className="mission-vision-thumb">
            <Image
              src={frontendImage(content?.thumb_image, "mission_vision")}
              alt={trans("Mission & Vision Image")}
              width={632}
              height={666}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
